import { FiArrowDownCircle } from "react-icons/fi";

const SalaryAndContract = ({ t }) => {
  return (
    <div className="bg-[#182443] p-8 rounded-lg space-y-4">
      <h3 className="text-lg font-bold">{t("salaryAndContract")}</h3>
      <div className="flex flex-wrap items-center md:flex-nowrap">
        <div className="w-full">
          <p>{t("baseSalary")}:</p>
          <p className="mt-2 text-xl font-semibold text-primary">8000</p>
        </div>
        <div className="w-full">
          <p>{t("allowances")}:</p>
          <p className="mt-2 text-xl font-semibold text-primary">1200</p>
        </div>
        <div className="w-full">
          <p>{t("bankAccount")}</p>
          <p className="mt-2 text-xl font-semibold">البنك الأهلي السعودي</p>
        </div>
      </div>
      <div className="flex flex-wrap items-center md:flex-nowrap">
        <div className="w-full">
          <p>{t("totalSalary")}:</p>
          <p className="mt-2 text-xl font-semibold text-primary">92000</p>
        </div>
        <div className="w-full">
          <p>{t("lastSalaryEdit")}:</p>
          <p className="mt-2 text-xl font-semibold">01-01-2025</p>
        </div>
        <div className="w-full">
          <p>{t("IPANNumber")}</p>
          <p className="mt-2 text-xl font-semibold ">SAXXXXXXXXXXXX</p>
        </div>
      </div>
      <div className="flex flex-wrap items-center md:flex-nowrap">
        <div className="w-full">
          <p>{t("contractCopy")}:</p>
          <p className="mt-2 text-xl font-semibold ">
            العقد.pdf <FiArrowDownCircle className="inline" />
          </p>
        </div>
        <div className="w-full">
          <p>{t("contractEndDate")}:</p>
          <p className="mt-2 text-xl font-semibold ">01-01-2026</p>
        </div>
        <div className="w-full">
          <p>{t("accountPic")}</p>
          <p className="mt-2 text-xl font-semibold ">
            .pdfالحساب <FiArrowDownCircle className="inline" />
          </p>
        </div>
      </div>
    </div>
  );
};

export default SalaryAndContract;
